import { ID } from '@datorama/akita';
import { mParticleInstance } from './mparticle';

// Declare gTM dataLayer array.
declare global {
  interface Window {
    dataLayer: any[];
    mParticle: mParticleInstance;
  }

  function gtag(...arguments: any[]): void;
  function fbq(...arguments: any[]): void;
}

export const G_TAG_ORDER = 'order';

export interface GA4_ECommerce {
  transaction_id: string;
  affiliation: string;
  value: number;
  tax: number;
  shipping: number;
  currency: 'DKK';
  coupon?: string;
  items: GA4_Item[];
}

export interface GA4_UserData {
  email: string;
  phone_number: string;
  address: {
    first_name: string;
    last_name: string;
    street: string;
    postal_code: string;
    city: string;
    country: 'dk';
  }[];
}

export interface GA4_Item {
  item_id: string;
  item_name: string;
  affiliation: string;
  currency: 'DKK';
  discount?: number;
  price: number;
  quantity: number;
  coupon?: string;
}

export interface Product {
  id: ID;
  name: string;
  price: string | number;
  brand?: string;
  category?: string;
  variant?: string;
  quantity: number;
  coupon?: string;
}
